
import { defineComponent, PropType } from 'vue';
import { ITicketMessage, IUser } from '@/types/models';
import { MessageType } from '@/types/enums';
import utils from '@/utils';

export default defineComponent({
  name: 'MessageList',
  props: {
    user: {
      type: Object as PropType<IUser>,
      required: true,
    },
    messages: {
      type: Object as PropType<ITicketMessage[]>,
      required: true,
    },
    isReply: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getClassName(message: ITicketMessage) {
      if (this.isReply) {
        return message.isReply ? 'message-item--right' : 'message-item--left';
      }
      return message.isReply ? 'message-item--left' : 'message-item--right';
    },

    isImage(message: ITicketMessage) {
      return message.messageType === MessageType.Image;
    },

    isDocument(message: ITicketMessage) {
      return message.messageType === MessageType.Document;
    },

    getStorageUrl(message: ITicketMessage) {
      return utils.getStorageUrl(message.storageKey);
    },

    getAvatarUrl() {
      return utils.getAvatarUrl(this.user);
    },

    getFileName(url: string) {
      return utils.getFileName(url);
    },
  },
});
